export enum PaymentFailCode {
  InsufficientFunds = 1,
  IncorectData = 2,
  TryAgain = 3,
  TransactionRefused = 4,
}

export const TextByError = {
  [PaymentFailCode.InsufficientFunds]: 'Недостаточно средств на карте',
  [PaymentFailCode.IncorectData]: 'Некорректные данные карты',
  [PaymentFailCode.TryAgain]: 'Попробуйте ещё раз',
  [PaymentFailCode.TransactionRefused]: 'Ваш банк отклонил операцию',
}
